"use client";

import Link from "next/link";
import { CheckCircle2, ShieldCheck } from "lucide-react";

import { Button } from "@/components/ui/button";
import { useI18n } from "@/components/i18n-provider";

/**
 * Honest risk-remover close for the offer page. Lists only verifiable
 * reassurances (no refund or job guarantees) and sends high-intent visitors
 * back up to the bundle section instead of out to the free tier. The free
 * review stays available as a quiet secondary link.
 */
export function OfferGuaranteeBand() {
  const { locale, dictionary } = useI18n();
  const copy = dictionary.dashboard.offerPage.guarantee;

  return (
    <section className="rounded-3xl bg-text-heading px-8 py-10 sm:px-10">
      <div className="grid items-center gap-8 md:grid-cols-[1fr_auto]">
        <div>
          <div className="flex items-center gap-4">
            <span className="flex size-12 flex-none items-center justify-center rounded-2xl bg-white/10 text-white">
              <ShieldCheck className="size-6" aria-hidden="true" />
            </span>
            <h3 className="text-xl font-bold text-white md:text-2xl">
              {copy.title}
            </h3>
          </div>
          <ul className="mt-6 grid gap-x-8 gap-y-3 sm:grid-cols-2">
            {copy.items.map((item) => (
              <li
                key={item}
                className="flex items-start gap-2 text-sm leading-6 text-white/80"
              >
                <CheckCircle2
                  className="mt-1 size-4 flex-none text-white"
                  aria-hidden="true"
                />
                {item}
              </li>
            ))}
          </ul>
        </div>
        <div className="flex flex-col items-start gap-3 md:items-center">
          <Button
            asChild
            className="min-h-12 bg-white px-6 text-base font-semibold text-text-heading hover:bg-white/90"
          >
            <Link href="#career-os-bundle">{copy.cta}</Link>
          </Button>
          <Link
            href={`/${locale}/review-cv-gratis`}
            className="text-sm text-white/60 underline underline-offset-4 transition-colors hover:text-white"
          >
            {copy.secondaryCta}
          </Link>
        </div>
      </div>
    </section>
  );
}
